import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "c-card-info w-full bg-primary-base rounded-lg border border-neutral-light" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Filtros por análises", -1)
const _hoisted_3 = {
  key: 0,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M5 15l7-7 7 7"
}, null, -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "w-6 h-6",
  fill: "none",
  stroke: "currentColor",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("path", {
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2",
  d: "M19 9l-7 7-7-7"
}, null, -1)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "c-card-info__content p-5 md:grid grid-cols-3 gap-4" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-center pb-8 md:pb-0" }, [
  /*#__PURE__*/_createElementVNode("h2", { class: "text-secondary-base text-3xl font-bold mb-2 text-left break-words" }, " Análises sobre as candidaturas "),
  /*#__PURE__*/_createElementVNode("p", { class: "text-white" }, " Ao clicar nas perguntas, você verá apenas as candidaturas que atendam aos critérios selecionados na listagem abaixo. ")
], -1)
const _hoisted_11 = { class: "col-span-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiltersAnalysis = _resolveComponent("FiltersAnalysis")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["c-card-info__title w-full flex flex-wrap justify-between text-center text-white bg-primary-dark rounded-t-lg py-5 px-5 text-base font-semibold", !_ctx.isOpenAnalisys ? 'rounded-b-xl' : 'rounded-none']),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isOpenAnalisys = !_ctx.isOpenAnalisys))
    }, [
      _hoisted_2,
      _createElementVNode("span", null, [
        (_ctx.isOpenAnalisys)
          ? (_openBlock(), _createElementBlock("svg", _hoisted_3, _hoisted_5))
          : (_openBlock(), _createElementBlock("svg", _hoisted_6, _hoisted_8))
      ])
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.isOpenAnalisys ? 'd-block' : 'hidden')
    }, [
      _createElementVNode("div", _hoisted_9, [
        _hoisted_10,
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_FiltersAnalysis)
        ])
      ])
    ], 2)
  ]))
}